module.exports = "<my-title\n  my-label=\"'Les wagons ont bien été annoncés en ferraillage'\"\n  my-style=\"$root.styles.titles.center\"\n  my-level=\"3\"\n>\n</my-title>\n\n<div class=\"section center\">\n  <my-button\n    my-label=\"$root.labels.wagon.statements.newManeuver\"\n    my-icon=\"$root.icons.back\"\n    my-style=\"$root.styles.dark()\"\n    my-click=\"goToSelectWagons()\"\n  >\n  </my-button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/maneuver/announce/templates/report.html
// module id = 1579
// module chunks = 0